"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _SttButton = _interopRequireDefault(require("./SttButton/SttButton"));
var _ErrorOutlineSharp = _interopRequireDefault(require("@material-ui/icons/ErrorOutlineSharp"));
var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));
var _HighlightOff = _interopRequireDefault(require("@material-ui/icons/HighlightOff"));
var _CheckCircleOutline = _interopRequireDefault(require("@material-ui/icons/CheckCircleOutline"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var paletteKey = {
  alert: 'alert',
  confirmation: 'primary',
  success: 'success',
  error: 'error'
};
var ALERT_COLORS = {
  alert: '#FFAB40',
  confirmation: '#0A6FB8',
  success: '#73BA6C',
  error: '#E05745'
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    box: {
      width: 'auto',
      minWidth: 400,
      maxWidth: 600,
      padding: 5,
      borderRadius: 4,
      overflowX: 'hidden'
    },
    ModalBackground: {
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.5)',
      backdropFilter: 'blur(5px)',
      zIndex: 1200
    },
    tituloContainer: {
      padding: theme.spacing(3, 3, 1),
      textAlign: 'center'
    },
    cabecalho: {
      textAlign: 'center',
      fontWeight: 700,
      fontSize: 22,
      wordBreak: 'break-word'
    },
    conteudo: {
      fontWeight: 400,
      fontSize: 15,
      color: theme.palette.text.primary,
      textAlign: 'center',
      whiteSpace: 'pre-line'
    },
    conteudoDialogo: {
      padding: theme.spacing(0, 2)
    },
    acoes: {
      justifyContent: 'flex-end',
      padding: theme.spacing(1),
      gap: theme.spacing(1)
    },
    iconWrapper: function iconWrapper(_ref) {
      var _ALERT_COLORS$type;
      var type = _ref.type;
      return {
        color: (_ALERT_COLORS$type = ALERT_COLORS[type]) !== null && _ALERT_COLORS$type !== void 0 ? _ALERT_COLORS$type : theme.palette.primary.main
      };
    }
  };
});
var SttAlerta = function SttAlerta(_ref2) {
  var _iconMap$type;
  var title = _ref2.title,
    message = _ref2.message,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'alert' : _ref2$type,
    _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? [] : _ref2$options,
    _ref2$onClose = _ref2.onClose,
    onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose,
    _ref2$open = _ref2.open,
    open = _ref2$open === void 0 ? false : _ref2$open,
    _ref2$blurBackground = _ref2.blurBackground,
    blurBackground = _ref2$blurBackground === void 0 ? false : _ref2$blurBackground;
  var classes = useStyles({
    type: type
  });
  var iconMap = {
    alert: /*#__PURE__*/_react["default"].createElement(_ErrorOutlineSharp["default"], {
      style: {
        fontSize: 33
      },
      className: classes.iconWrapper
    }),
    confirmation: /*#__PURE__*/_react["default"].createElement(_HelpOutline["default"], {
      style: {
        fontSize: 33
      },
      className: classes.iconWrapper
    }),
    success: /*#__PURE__*/_react["default"].createElement(_CheckCircleOutline["default"], {
      style: {
        fontSize: 33
      },
      className: classes.iconWrapper
    }),
    error: /*#__PURE__*/_react["default"].createElement(_HighlightOff["default"], {
      style: {
        fontSize: 33
      },
      className: classes.iconWrapper
    })
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, open && blurBackground && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.ModalBackground
  }), /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    open: open,
    onClose: onClose,
    classes: {
      paper: classes.box
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, {
    disableTypography: true,
    classes: {
      root: classes.tituloContainer
    }
  }, (_iconMap$type = iconMap[type]) !== null && _iconMap$type !== void 0 ? _iconMap$type : null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.cabecalho
  }, title)), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, {
    className: classes.conteudoDialogo
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogContentText, {
    className: classes.conteudo
  }, message)), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index
    }, index === 0 ? /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        return option.onClick(option.params);
      },
      style: {
        fontWeight: option.fontWeight || 500
      }
    }, option.title) : /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      variant: "outlined",
      color: "primary",
      onClick: function onClick() {
        return option.onClick(option.params);
      },
      style: {
        fontWeight: option.fontWeight || 500
      }
    }, option.title));
  }))));
};
SttAlerta.propTypes = {
  title: _propTypes["default"].string,
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  type: _propTypes["default"].string,
  options: _propTypes["default"].array,
  onClose: _propTypes["default"].func,
  open: _propTypes["default"].bool,
  blurBackground: _propTypes["default"].bool
};
var _default = SttAlerta;
exports["default"] = _default;